export default __webpack_public_path__ + "static/bigData-4742c53a867b1aac4dd0a64520131bb8.png";